import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { X, Sparkles } from "lucide-react";

const DISMISS_KEY = "aios_trial_bar_dismissed"; // fecha (yyyy-mm-dd)

// Invita a activar la prueba de 14 días CON tarjeta (sin cargo hoy). Solo se
// muestra a cuentas de prueba que aún no han metido tarjeta; los de pago, el
// dueño y quien ya tiene tarjeta no lo ven.
export default function TrialBanner() {
  const nav = useNavigate();
  const [st, setSt] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/billing/status")
      .then((r) => { if (alive) setSt(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!st || st.is_paid || st.is_platform_owner || st.plan !== "trial" || st.has_card) return null;

  const today = new Date().toISOString().slice(0, 10);
  if (hidden || localStorage.getItem(DISMISS_KEY) === today) return null;

  return (
    <div className="flex items-center justify-center gap-3 px-4 py-2 bg-[var(--accent)]/10 border-b border-[var(--accent)]/40 text-sm">
      <Sparkles className="w-4 h-4 text-[var(--accent)] shrink-0" />
      <span className="text-[var(--text-dim)]">
        Activa tu <b className="text-white">prueba gratuita de 14 días</b> — sin cargo hoy, cancela cuando quieras.
      </span>
      <button onClick={() => nav("/precios")} className="text-[var(--accent)] font-semibold hover:underline">
        Empezar prueba
      </button>
      <button
        onClick={() => { localStorage.setItem(DISMISS_KEY, today); setHidden(true); }}
        className="ml-1 text-[var(--text-dim)] hover:text-white"
        aria-label="Cerrar"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
